import * as angular from 'angular';
import * as $ from 'jquery';

import { QueryDataService } from '../../services/query-data-service';
import RenameQueryModalController from './rename-query-modal-controller';
import template from './rename-query-modal.html';

const EVENT_NAME = 'click.renameQueryModal';

const renameQueryModalDirective = function (Modal, queryDataService: QueryDataService) {
  return {
    restrict: 'A',
    scope: {
      query: '<',
    },
    link: function ($scope: angular.IScope, elem, attrs) {
      elem.on(EVENT_NAME, (event) => {
        const modal = Modal.open(
          {
            queryName: $scope.query.name,
          },
          {
            template: template,
            controller: RenameQueryModalController,
            controllerAs: 'ctrl',
            bindToController: true,
          }
        );
        modal.result
          .then((response: { name: string }) => {
            queryDataService.updateQueryName($scope.query.token, response.name);
          })
          .catch(() => {});
      });

      // cleanup handlers
      $scope.$on('$destroy', () => elem.off(EVENT_NAME));
    },
  };
};

renameQueryModalDirective.$inject = ['ModalService', 'QueryDataService'];

angular.module('mode.components').directive('renameQuery', renameQueryModalDirective);
